<template>
    <p>{{getPaymentMessage()}} <span v-if="message">( {{message}} )</span></p>
</template>

<script>
    export default {
        props: ["message", "isPaid"],
        methods: {


            getPaymentMessage() {
                if (this.isPaid) {
                    return this.Lang.get('messages.cancel_payment_confirmation');
                } else {
                    return this.Lang.get('messages.confirm_payment_confirmation');
                }
                

               
            }
        }
    };

</script> 

<style>
</style>
